module.exports = require('./lib/keyword_extractor');